import {
  getDecryptID,
  isEmptyObject,
  getRandomInt,
  clusterCalculations,
  formatDigits,
  customParse,
  parseFloatCustom,
  calculateRevBasedTax,
  fetchCurrentSalesOrder,
  indexUpdateAllPaid,
  putIndexSalePaymentInProgress,
  getSalesOrderID,
  generateSaleBarcode
} from './GlobalMethods'
import {
  loadSaleProductJsonData,
  loadSalePaymentData,
  loadCustomerSearchData,
  loadShowInventoryPopup
} from './Sell'
import { getProductPriceBook } from './PBookPromotionsMethod'
import {
  loadSaleOrderJson,
  loadTableDataSellTax,
  loadTableDataSellPromotion,
  loadIsProductLoading,
  loadSalePayments,
  loadIsPaymentPanelActionCompleteActive,
  loadDataToPrint,
  loadCurrentSalesOrderStatusName,
  loadCurrentSalesOrderStatusID,
  loadIsSalePaymentProcessStart,
  loadFormAmountToPay,
  loadRefundProdKeys,
  loadIsMainLoading,
  loadIsPromoCodePopoverVisible,
  laodPromoCodeNotify,
  loadIsPaymentPanelLoading
} from './MainSale'
import {
  calculateDiscountPercent,
  calculateRefundPrice,
  priceBookEffects,
  prodTaxHelper
} from './ProdHelperMethods'
import {
  bestPriceSelection,
  promoPriceEffect,
  promotionHelper
} from './ProdHelperMethods'
import moment from 'moment'
import { message } from 'antd'
import { manageIndexedCartJson } from './saleIndexDB'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from './IndexDBActions'

export function SellProductJsonBuilderRunner (
  SaleOrderJsonData,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getCustomerSearchData,
  getIsRefundSale,
  getDefaultDecimalPlaces,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  getReduxSaleProductJsonData,
  getStoredBooks,
  getIsLoyaltyEnabled,
  getDefaultLoyaltyAmount,
  getIsTaxExclusive,
  getStoredPromos,
  getRefundKeys,
  getSalePayments,
  dispatch,
  getSavings,
  attribProps
) {
  if (SaleOrderJsonData && !isEmptyObject(SaleOrderJsonData)) {
    let saleOrderData = SaleOrderJsonData
    let refundProdKeys = getRefundKeys
    // let customerobj = {
    //   customerGroupId: !StringIsUndefinedOrEmpty(saleOrderData.sCustomerGroupId)
    //     ? saleOrderData.sCustomerGroupId
    //     : "",
    //   customerSId: !StringIsUndefinedOrEmpty(saleOrderData.sCustomerID)
    //     ? saleOrderData.sCustomerID
    //     : "",
    //   customerCode: !StringIsUndefinedOrEmpty(saleOrderData.customerCode)
    //     ? saleOrderData.customerCode
    //     : "",
    //   letterName: !StringIsUndefinedOrEmpty(saleOrderData.letterName)
    //     ? saleOrderData.letterName
    //     : "",
    //   customerFirstName: !StringIsUndefinedOrEmpty(saleOrderData.firstName)
    //     ? saleOrderData.firstName
    //     : "",
    //   customerLastName: !StringIsUndefinedOrEmpty(saleOrderData.lastName)
    //     ? saleOrderData.lastName
    //     : "",
    //   groupName: !StringIsUndefinedOrEmpty(saleOrderData.customerGroupName)
    //     ? saleOrderData.customerGroupName
    //     : "",
    // };
    // // if (saleOrderData.key != undefined && saleOrderData.key!="") {
    // //   //|| saleOrderData.key!= undefined

    // // }
    // // setCustomerObj(customerobj); // idhar masla hy agr pehly customer add krdo then product add kro tw ye null kr rhaa hy
    const cus =
      getCustomerSearchData && !isEmptyObject(getCustomerSearchData)
        ? getCustomerSearchData
        : SaleOrderJsonData.customer && SaleOrderJsonData.customer.length > 0
        ? SaleOrderJsonData.customer[0]
        : {}
    if (cus && !isEmptyObject(cus)) {
      dispatch(loadCustomerSearchData(cus))
    }
    let productsData = saleOrderData.products
      ? saleOrderData.products
      : saleOrderData.productsReplica
    let items = productsData && productsData.length > 0 ? productsData : []
    let sProducts = []

    items &&
      items.map(item => {
        if (saleOrderData.firstRefund) {
          item.firstRefund = true
        }
        const productClone = SellProductJsonBuilder(
          item,
          {},
          'runner',
          getCustomerSearchData,
          getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscountPrice,
          formDiscountPercentage,
          formSellNotes,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'SellProductJsonBuilderRunner',
          false,
          attribProps
        )
        if (productClone && !isEmptyObject(productClone)) {
          sProducts.push(productClone)
        }
      })

    if (saleOrderData.isRefund) {
      refundProdKeys = sProducts.map(ax =>
        ax.sSalesOrderItemID ? getDecryptID(ax.sSalesOrderItemID) : ''
      )
      if (refundProdKeys && refundProdKeys.length > 0) {
        refundProdKeys = refundProdKeys.filter(a => a != '')
        dispatch(loadRefundProdKeys(refundProdKeys))
      }
    }
    dispatch(loadSaleProductJsonData(sProducts))
    clusterCalculations(
      sProducts,
      getSelectedOutlet,
      getSelectedReg,
      getBasicIsPercent,
      getCustomerSearchData,
      getIsRefundSale,
      getDefaultDecimalPlaces,
      getCurrentSalesOrderData,
      getCurrentSalesOrderStatusID,
      formDiscountPrice,
      formDiscountPercentage,
      formSellNotes,
      refundProdKeys, //getRefundKeys,
      getSalePayments,
      dispatch,
      getStoredPromos,
      getIsTaxExclusive,
      saleOrderData.firstRefund ? true : false,
      getSavings,
      attribProps
    )
  }
}

export function SellTaxCalculator (items, dispatch) {
  let tempDataStore = []
  for (let k = 0; k < items.length; k++) {
    if (
      items[k] &&
      items[k].taxComponents &&
      !isEmptyObject(items[k].taxComponents)
    ) {
      let mapped = items[k].taxComponents.map(obj => {
        return {
          fixRate: obj.fixRate ? obj.fixRate : 0,
          isFix: obj.isFix ? obj.isFix : false,
          key: obj.taxId,
          sellTaxName: obj.taxName,
          sellTaxRate: obj.taxRate,
          sellTaxPrice: obj.total_tax //we need to add discount logic here,,iscount wala price bhe asakty hen ,,jb row me discount hota hy
        }
      })
      tempDataStore.push(mapped)
    }
  }

  tempDataStore = tempDataStore.filter(value => Object.keys(value).length !== 0)
  if (tempDataStore && !isEmptyObject(tempDataStore)) {
    const filtertableSellTaxData = tempDataStore
      .flat(1)
      .reduce(
        (
          acc,
          { key, sellTaxName, sellTaxRate, sellTaxPrice, isFix, fixRate }
        ) => {
          const existing = acc.find(
            i => getDecryptID(i.key) === getDecryptID(key)
          )
          if (existing) {
            existing.sellTaxPrice += sellTaxPrice
          } else {
            acc.push({
              fixRate,
              isFix,
              key,
              sellTaxName,
              sellTaxRate,
              sellTaxPrice: sellTaxPrice
            })
          }
          return acc
        },
        []
      )
    dispatch(loadTableDataSellTax(filtertableSellTaxData))
  } else {
    dispatch(loadTableDataSellTax([]))
  }
}

export function wholeDiscTaxCalculator (tempDataStore, dispatch) {
  let res = {
    tax: 0
  }
  tempDataStore = tempDataStore.filter(value => Object.keys(value).length !== 0)
  if (tempDataStore && !isEmptyObject(tempDataStore)) {
    const filtertableSellTaxData = tempDataStore
      .flat(1)
      .reduce(
        (
          acc,
          { key, sellTaxName, sellTaxRate, sellTaxPrice, isFix, fixRate }
        ) => {
          const existing = acc.find(
            i => getDecryptID(i.key) === getDecryptID(key)
          )
          if (existing) {
            existing.sellTaxPrice += sellTaxPrice
          } else {
            acc.push({
              fixRate,
              isFix,
              key,
              sellTaxName,
              sellTaxRate,
              sellTaxPrice: sellTaxPrice
            })
          }
          return acc
        },
        []
      )
    dispatch(loadTableDataSellTax(filtertableSellTaxData))
    res.tax =
      filtertableSellTaxData && filtertableSellTaxData != undefined
        ? filtertableSellTaxData.reduce((a, v) => (a = a + v.sellTaxPrice), 0)
        : 0
  } else {
    dispatch(loadTableDataSellTax([]))
  }
  return res
}

export function SellPromotionCalculator (saleProductData, dispatch) {
  let tempDataStore = []
  let items = saleProductData
  for (let k = 0; k < items.length; k++) {
    ////
    let mapped = {}
    let saleData = items
    if (saleData[k] != undefined) {
      if (
        saleData[k].PromotionandPriceBookDetails &&
        saleData[k].PromotionandPriceBookDetails.AppliedPromotionDetails
      ) {
        mapped = saleData[
          k
        ].PromotionandPriceBookDetails.AppliedPromotionDetails.map(obj => {
          let promoAmount = 0
          if (saleData[k].isPromotionApplied) {
            if (false) {
              //saleData[k].PromotionandPriceBookDetails.appliedPromoClone.isPayFix
              const val =
                saleData[k].totals.displayBasePrice -
                saleData[k].totals.displayPrice
              promoAmount = customParse(val)
            } else {
              promoAmount = obj.amount
            }
          }
          return {
            promotionID: obj.id,
            promotionName: obj.name,
            promotionAmount: promoAmount,
            // promotionAmount: customParse(obj.amount),
            promoCode: obj.promoCode
          }
        })
      }
    }

    tempDataStore.push(mapped)
  }

  const filtertableSellPromotionData = tempDataStore
    .flat(1)
    .reduce(
      (acc, { promotionID, promotionName, promotionAmount, promoCode }) => {
        const existing = acc.find(i => i.promotionID === promotionID)
        if (existing) {
          existing.promotionAmount += promotionAmount
        } else {
          acc.push({
            promotionID,
            promotionName,
            promoCode,
            promotionAmount: promotionAmount
          })
        }
        return acc
      },
      []
    )
  // setTableDataSellPromotion(filtertableSellPromotionData);
  dispatch(loadTableDataSellPromotion(filtertableSellPromotionData))
}

export function SellPaymentCalculator (
  body,
  getSaleOrderJson,
  getDefaultDecimalPlaces,
  getSalePayments,
  getCurrentSalesOrderData,
  getCustomerSearchData,
  getTableDataSellTax,
  getIsRefundSale,
  getIsExchangeSale,
  getCurrentSalesOrderStatusID,
  dispatch,
  getReduxStoreInfo,
  getDiscountPriceTotal,
  getTableDataSellPromotion,
  getSavings,
  getIsTaxExclusive,
  sellSelData,
  earnedLoyalty,
  allowPrintToShow,
  showTaxCode
) {
  let tempPaymentData = body
  const alreadyComp = tempPaymentData.alreadyCompleted ? true : false
  const allow =
    tempPaymentData.isPaid && tempPaymentData.isOk ? true : alreadyComp
  if (allow) {
    let tempSaleOrderJson = getSaleOrderJson
    let amountCheck = -1
    let change = getSaleOrderJson.Change
    let wholePayData = getSalePayments
    if (alreadyComp) {
      amountCheck = 0
    } else {
      let paymentDate =
        moment(tempPaymentData.paymentOn).format('dddd') +
        ' ' +
        moment(tempPaymentData.paymentOn).format('MMMM Do YYYY, h:mm a')

      let paymentData = {
        paymentTypeID: '',
        paymentName: tempPaymentData.gateway,
        amount: tempPaymentData.amount,
        paymentDate: paymentDate,
        paymentOnShort: tempPaymentData.paymentOnShort
      }

      amountCheck =
        (getSaleOrderJson.AmountToPay
          ? customParse(getSaleOrderJson.AmountToPay)
          : 0) - (paymentData.amount ? customParse(paymentData.amount) : 0)
      if (
        Math.sign(amountCheck) == -1 &&
        Math.sign(getSaleOrderJson.AmountToPay) != -1
      ) {
        change = amountCheck * -1
        amountCheck = 0
      }

      wholePayData = getSalePayments.concat(paymentData)
      dispatch(loadSalePayments(wholePayData))
    }

    const formSetAmountToPay = customParse(amountCheck)
    dispatch(loadFormAmountToPay(formSetAmountToPay))
    tempSaleOrderJson.AmountToPay = amountCheck
    tempSaleOrderJson.Balance = amountCheck
    tempSaleOrderJson.Change = customParse(change)
    dispatch(loadSaleOrderJson(tempSaleOrderJson))
    // manageIndexedCartJson(
    //   tempSaleOrderJson,
    //   true,
    //   false,
    //   false,
    //   'SellPaymentCalculator'
    // )
    dispatch(loadIsSalePaymentProcessStart(true))
    const orderGuidID = getSalesOrderID()
    const amount = customParse(amountCheck)
    const data = {
      orderGuidID: orderGuidID,
      amount: amount
    }
    dispatch(loadSalePaymentData(data))

    let isCompleted = false
    if (amountCheck == 0) {
      tempSaleOrderJson.isAllPaid = true
      isCompleted = true
      // indexUpdateAllPaid(tempSaleOrderJson.indexKey)
      if (true) {
        // allowPrintToShow // // // NOTE: True because there is a button to send print
        CalculateReceiptTemplateJson(
          tempSaleOrderJson,
          getCurrentSalesOrderData,
          getCustomerSearchData,
          getTableDataSellTax,
          dispatch,
          getReduxStoreInfo,
          getDefaultDecimalPlaces,
          getDiscountPriceTotal,
          wholePayData,
          '',
          getTableDataSellPromotion,
          getIsRefundSale,
          getSavings,
          getIsTaxExclusive,
          sellSelData,
          earnedLoyalty,
          'SellPaymentCalculator',
          showTaxCode
        )
      }
      if (getDecryptID(getCurrentSalesOrderStatusID) == '15') {
        // getIsRefundSale
        if (getIsExchangeSale) {
          dispatch(loadCurrentSalesOrderStatusName('Exchange, Completed'))
          dispatch(
            loadCurrentSalesOrderStatusID(
              '16&&_9efa-1ea9-4faf-88ed-a48e65b46643'
            ) //exchange Completed
          )
        } else {
          dispatch(loadCurrentSalesOrderStatusName('Return, completed'))
          dispatch(
            loadCurrentSalesOrderStatusID(
              '13&&_9efa-1ea9-4faf-88ed-a48e65b46643'
            ) //return Completed
          )
        }
      } else {
        if (getDecryptID(getCurrentSalesOrderStatusID) == '2') {
          dispatch(loadCurrentSalesOrderStatusName('On Account, completed'))
          dispatch(
            loadCurrentSalesOrderStatusID(
              '8&&_9efa-1ea9-4faf-88ed-a48e65b46643'
            ) //onAccount Completed
          )
        } else if (getDecryptID(getCurrentSalesOrderStatusID) == '1') {
          dispatch(loadCurrentSalesOrderStatusName('Layby, completed'))
          dispatch(
            loadCurrentSalesOrderStatusID(
              '7&&_9efa-1ea9-4faf-88ed-a48e65b46643'
            ) //layby Completed
          )
        } else {
          if (
            getDecryptID(getCurrentSalesOrderStatusID) != '4' &&
            getDecryptID(getCurrentSalesOrderStatusID) != '5'
          ) {
            dispatch(loadCurrentSalesOrderStatusName('Completed'))
            dispatch(
              loadCurrentSalesOrderStatusID(
                '6&&_9efa-1ea9-4faf-88ed-a48e65b46643'
              ) //Completed
            )
          }
        }
      }
    }

    // // // NOTE: index management
    putIndexSalePaymentInProgress(
      tempSaleOrderJson,
      tempPaymentData,
      'SellPaymentCalculator'
    )
    if (isCompleted)
      dispatch(
        loadIsPaymentPanelActionCompleteActive(true, 'SellPaymentCalculator')
      )
  }
}

export function CalculateReceiptTemplateJson (
  getSaleOrderJson,
  getCurrentSalesOrderData,
  getCustomerSearchData,
  getTableDataSellTax,
  dispatch,
  getReduxStoreInfo,
  getDefaultDecimalPlaces,
  getDiscountPriceTotal,
  getSalePayments,
  saleNature,
  getTableDataSellPromotion,
  getIsRefundSale,
  getSavings,
  getIsTaxExclusive,
  sellSelData,
  earnedLoyalty,
  callFrom,
  showTaxCode
) {
  const decimal = getDefaultDecimalPlaces ? getDefaultDecimalPlaces : 2
  // const objData = getSaleOrderJson; // jugarh for bhund of 2 diff obj
  const sale = getSaleOrderJson // jugarh for bhund of 2 diff obj
  let productsData = []
  if (sale && sale.Products && sale.Products.length) {
    productsData = sale.Products
  }
  const changeValue =
    getSaleOrderJson && getSaleOrderJson.Change != undefined
      ? formatDigits(getSaleOrderJson.Change, getDefaultDecimalPlaces)
      : 0

  const salesOrderData = sale
  let selectedCustomer = getCustomerSearchData
  let toPrintTaxes = []
  let toPrintPayment = []
  let toPrintProducts = []
  let dataToPrint = {
    balance: 0,
    customerCode: '',
    customerEmail: '',
    customerAddress: '',
    customerPhone: '',
    customerGroupName: '',
    discountIsPercentage: false,
    discountPercentage: 0,
    firstName: '',
    key: '',
    lastName: '',
    Notes: '',
    outletName: '',
    receipt: 0,
    registerName: '',
    sCreatedBy: '',
    sCustomerGroupId: '',
    sCustomerID: '',
    sOutletID: '',
    sSalesOrderStatusID: '',
    sUpdatedBy: '',
    salesOrderDiscountPrice: 0,
    sellDate: '',
    soldBy: '',
    status: '',
    storeName: '',
    totalPrice: 0,
    totalTax: 0,
    taxes: [],
    taxesSum: [],
    payments: [],
    products: [],
    additionalDiscount: '',
    toPay: '',
    saleNature: '',
    totalSavings: '',
    saleid: '',
    isRefundSale: getIsRefundSale ? getIsRefundSale : false,
    totalItems: 0,
    change: changeValue,
    sellSelData: sellSelData && sellSelData.length > 0 ? sellSelData : [],
    totalLoyaltyValue: earnedLoyalty ? earnedLoyalty : 0,
    indexKey: 0,
    isOffline: false,
    barcode: false
  }

  // if (getDecryptID(salesOrderData.E_SalesOrderStatusID) == getDecryptID(fetchCurrentSalesOrder("On Account")) ||
  //   getDecryptID(salesOrderData.E_SalesOrderStatusID) == getDecryptID(fetchCurrentSalesOrder("LayBy"))) {
  //   dataToPrint.toPay = salesOrderData.TotalPrice ? formatDigits(salesOrderData.TotalPrice, decimal) : "";
  // }
  dataToPrint.toPay = salesOrderData.AmountToPay
    ? formatDigits(salesOrderData.AmountToPay, decimal)
    : ''
  // dataToPrint.balance = salesOrderData.Balance ? formatDigits(salesOrderData.Balance, decimal) : 0;
  dataToPrint.discountIsPercentage = salesOrderData.DiscountIsPercentage
    ? salesOrderData.DiscountIsPercentage
    : ''
  dataToPrint.discountPercentage = salesOrderData.DiscountPercentage
    ? formatDigits(salesOrderData.DiscountPercentage, decimal)
    : 0
  dataToPrint.key = salesOrderData.E_SalesOrderID
    ? salesOrderData.E_SalesOrderID
    : ''

  dataToPrint.sSalesOrderStatusID = salesOrderData.E_SalesOrderStatusID
  dataToPrint.Notes = salesOrderData.Notes ? salesOrderData.Notes : ''
  // dataToPrint.receipt =  salesOrderData.E_SalesOrderID ? getDecryptID(salesOrderData.E_SalesOrderID) : "";

  dataToPrint.saleid = salesOrderData.E_SalesOrderID
    ? getDecryptID(salesOrderData.E_SalesOrderID)
    : ''
  //console.log('TC recessionIdentity ==> ', salesOrderData.receiptNo)
  dataToPrint.receipt = salesOrderData.receiptCode
    ? salesOrderData.receiptCode
    : ''
  // dataToPrint.receipt = salesOrderData.receiptNo ? salesOrderData.receiptNo : "";
  dataToPrint.salesOrderDiscountPrice = salesOrderData.SalesOrderDiscountPrice
    ? formatDigits(salesOrderData.SalesOrderDiscountPrice, decimal)
    : ''
  dataToPrint.totalPrice = salesOrderData.TotalPrice
    ? formatDigits(salesOrderData.TotalPrice, decimal)
    : ''
  dataToPrint.totalTax = salesOrderData.TotalTax
    ? formatDigits(salesOrderData.TotalTax, decimal)
    : ''

  dataToPrint.storeName =
    getReduxStoreInfo && getReduxStoreInfo.storeName
      ? getReduxStoreInfo.storeName
      : ''
  dataToPrint.saleNature = saleNature && saleNature != '' ? saleNature : ''
  dataToPrint.soldBy = getReduxStoreInfo.userName
    ? getReduxStoreInfo.userName
    : ''
  dataToPrint.soldBy = getReduxStoreInfo.userID
    ? `${dataToPrint.soldBy}(${getDecryptID(getReduxStoreInfo.userID)})`
    : dataToPrint.soldBy
  if (getSavings) {
    dataToPrint.totalSavings = getSavings
  } else {
    dataToPrint.totalSavings = ''
  }
  dataToPrint.customerCode = selectedCustomer.customerCode
    ? selectedCustomer.customerCode
    : ''
  dataToPrint.customerEmail = selectedCustomer.customerEmail
    ? selectedCustomer.customerEmail
    : ''
  dataToPrint.customerAddress = selectedCustomer.postalAddres
    ? selectedCustomer.postalAddres
    : selectedCustomer.postalAddres2
    ? selectedCustomer.postalAddres2
    : ''
  dataToPrint.customerPhone = selectedCustomer.contactNumber
    ? selectedCustomer.contactNumber
    : ''
  dataToPrint.customerGroupName = selectedCustomer.groupName
    ? selectedCustomer.groupName
    : ''
  dataToPrint.sCustomerGroupId = selectedCustomer.customerGroupId
    ? selectedCustomer.customerGroupId
    : ''
  dataToPrint.sCustomerID = selectedCustomer.customerSId
    ? selectedCustomer.customerSId
    : ''
  dataToPrint.firstName = selectedCustomer.customerFirstName
    ? selectedCustomer.customerFirstName
    : ''
  dataToPrint.lastName = selectedCustomer.customerLastName
    ? selectedCustomer.customerLastName
    : ''

  //for payment
  if (getSalePayments && getSalePayments.length > 0) {
    toPrintPayment = getSalePayments.map(x => {
      return {
        amount: x.amount ? formatDigits(x.amount, decimal) : '',
        paymentDate: x.paymentDate ? x.paymentDate : '',
        paymentName: x.paymentName ? x.paymentName : '',
        paymentOn: x.paymentOnShort
          ? x.paymentOnShort
          : x.paymentDate
          ? x.paymentDate
          : ''
      }
    })
  }
  dataToPrint.payments = toPrintPayment

  //for taxes
  if (productsData && productsData.length > 0) {
    let tempDataStore = []
    let items = productsData
    for (let k = 0; k < items.length; k++) {
      ////
      let mapped = {}
      let saleData = items
      if (saleData[k] != undefined) {
        if (
          saleData[k].TaxComponents &&
          !isEmptyObject(saleData[k].TaxComponents)
        ) {
          mapped = saleData[k].TaxComponents.map(obj => {
            const id = getDecryptID(
              obj.E_SalesOrderItemID
                ? obj.E_SalesOrderItemID
                : saleData[k].E_SalesOrderItemID
            ) // E_salesOrderItemID
            return {
              itemIdentifyID: id ? parseInt(id) : 0,
              sSalesOrderID: obj.E_SalesOrderID, // E_salesOrderID
              sSalesOrderItemID: obj.E_SalesOrderItemID, // E_salesOrderItemID
              sSalesOrderItemTaxID: obj.E_SalesOrderItemTaxID, // E_salesOrderItemTaxID
              sTaxID: obj.E_TaxId,
              saleTaxName: obj.TaxName,
              taxPrice: obj.Total_tax
                ? formatDigits(obj.Total_tax, decimal)
                : '0.00',
              taxValue: obj.TaxRate,
              isFix: obj.isFix,
              fixRate: obj.Base_tax,
              taxCode: showTaxCode ? obj.TaxCode : ''
            }
          })
        }
        tempDataStore.push(mapped)
      }
    }

    tempDataStore = tempDataStore.filter(
      value => Object.keys(value).length !== 0
    )
    if (tempDataStore && !isEmptyObject(tempDataStore)) {
      const filtertableSellTaxData = tempDataStore.flat(1)
      toPrintTaxes = filtertableSellTaxData
    }
  }
  dataToPrint.taxes = toPrintTaxes

  // for taxes sum
  if (
    salesOrderData.totalTaxComponent &&
    salesOrderData.totalTaxComponent.length > 0
  ) {
    dataToPrint.taxesSum = salesOrderData.totalTaxComponent.map(wx => {
      let taxModPrice = wx.total_tax
      if (!wx.isFix) {
        if (
          (salesOrderData.DiscountIsPercentage &&
            salesOrderData.DiscountIsPercentage) ||
          salesOrderData.SalesOrderDiscountPrice
        ) {
          taxModPrice -= taxModPrice * (salesOrderData.DiscountPercentage / 100)
        }
      }
      const tax_code = wx.taxCode ? wx.taxCode : wx.TaxCode ? wx.TaxCode : ''
      return {
        sSalesOrderID: salesOrderData.E_SalesOrderID,
        sTaxID: wx.e_TaxId,
        taxPrice: taxModPrice ? formatDigits(taxModPrice, decimal) : '0.00',
        saleTaxName: wx.taxName ? wx.taxName : '',
        taxValue: wx.taxRate ? formatDigits(wx.taxRate * 100, decimal) : '0.00',
        isFix: wx.isFix,
        fixRate: wx.fixRate ? formatDigits(wx.fixRate, decimal) : '0.00',
        taxCode: showTaxCode && tax_code ? tax_code : ''
      }
    })
  }

  // products
  let wholeDisc = 0
  if (productsData && productsData.length > 0) {
    let isLayByAccount = false
    productsData.map((d, i) => {
      if (d.isOnAccount) {
        isLayByAccount = true
      }
    })
    toPrintProducts = productsData.map(e => {
      if (salesOrderData.DiscountPercentage > 0) {
        if (salesOrderData.isRefund) {
          if (e.isRefund) {
            if (salesOrderData.isAccountRefund) {
              if (e.isRefund && e.isOnAccount) {
                wholeDisc += getIsTaxExclusive
                  ? e.UnitPrice * (salesOrderData.DiscountPercentage / 100)
                  : e.UnitPrice * (salesOrderData.DiscountPercentage / 100) +
                    e.TotalTaxWithoutFix *
                      (salesOrderData.DiscountPercentage / 100)
              }
            } else {
              wholeDisc += getIsTaxExclusive
                ? e.UnitPrice * (salesOrderData.DiscountPercentage / 100)
                : e.UnitPrice * (salesOrderData.DiscountPercentage / 100) +
                  e.TotalTaxWithoutFix *
                    (salesOrderData.DiscountPercentage / 100)
            }
          }
        } else {
          let allow = true
          if (isLayByAccount) {
            allow = e.isOnAccount ? true : false
          }
          if (allow) {
            wholeDisc += getIsTaxExclusive
              ? e.UnitPrice * (salesOrderData.DiscountPercentage / 100)
              : e.UnitPrice * (salesOrderData.DiscountPercentage / 100) +
                e.TotalTaxWithoutFix * (salesOrderData.DiscountPercentage / 100)
          }
        }
      }
      let price = e.TotalPrice ? formatDigits(e.TotalPrice, decimal) : ''
      if (getIsTaxExclusive) {
        price = e.UnitPrice ? formatDigits(e.UnitPrice, decimal) : ''
      }
      let promo = {}
      let priceBookValue = 0
      if (e.Promotions && e.Promotions.length > 0) {
        const pp = e.Promotions.map(qw => {
          return {
            promoJSON: qw.PromoJSON,
            e_PromotionID: qw.E_PromotionID,
            promotionValue: qw.PromotionValue,
            promotionName: qw.PromotionName,
            promoCodes:
              qw.PromoCodes && qw.PromoCodes.length > 0
                ? qw.PromoCodes.map(we => {
                    return {
                      codeID: we.CodeID,
                      codeName: we.CodeName
                    }
                  })
                : []
          }
        })
        if (pp && pp.length > 0) {
          promo = pp[0]
        }
      }
      if (e.PriceBooks && e.PriceBooks.length > 0) {
        const pb = e.PriceBooks.map(er => {
          return {
            pbValue: er.UnitPrice
          }
        })
        if (pb && pb.length > 0) {
          priceBookValue = pb[0].pbValue ? pb[0].pbValue : 0
        }
      }

      let tax = 0
      let taxCode = ''
      dataToPrint.taxes &&
        dataToPrint.taxes.length > 0 &&
        dataToPrint.taxes
          .filter(
            a => `${a.itemIdentifyID}` == getDecryptID(e.E_SalesOrderItemID)
          )
          .map(cc => {
            if (!cc.isFix) {
              tax += cc.taxValue
            }
            if (cc.taxCode) {
              taxCode += `${taxCode ? `, ${cc.taxCode}` : `${cc.taxCode}`}`
            }
          })
      // dataToPrint.taxes &&
      //   dataToPrint.taxes.length > 0 &&
      //   dataToPrint.taxes.map(cc => {
      //     if (cc.taxCode) {
      //       taxCode += `${taxCode ? `, ${cc.taxCode}` : `${cc.taxCode}`}`
      //     }
      //   })

      // const tax = dataToPrint.taxes && dataToPrint.taxes.length > 0 &&
      //   dataToPrint.taxes.filter(a => `${a.itemIdentifyID}` == getDecryptID(e.E_SalesOrderItemID)).length > 0 ?
      //   dataToPrint.taxes.filter(a => `${a.itemIdentifyID}` == getDecryptID(e.E_SalesOrderItemID))[0].taxValue : 0;
      const basePrice = e.BasePrice ? customParse(e.BasePrice) : 0
      const promoValue =
        promo && promo.promotionValue
          ? customParse(promo.promotionValue / e.Quantity)
          : 0
      const promoPercent = calculateDiscountPercent(
        getIsTaxExclusive,
        basePrice,
        tax ? customParse(tax) : 0,
        promoValue
      )
      const pbPercent = calculateDiscountPercent(
        getIsTaxExclusive,
        basePrice,
        tax ? customParse(tax) : 0,
        priceBookValue ? customParse(priceBookValue / e.Quantity) : 0
      )
      // dataToPrint.totalItems +=  e.Quantity ? e.Quantity : 0;
      return {
        discountIsPercentage: e.DiscountIsPercentage,
        discountPercentage: e.DiscountPercentage
          ? formatDigits(e.DiscountPercentage, decimal)
          : '0.00',
        itemIdentifyID: e.E_SalesOrderItemID,
        productName: e.ProductName,
        quantity: e.Quantity,
        sProductID: e.E_ProductID,
        sSalesOrderID: e.E_SalesOrderID,
        sSalesOrderItemID: e.E_SalesOrderItemID,
        basePrice: basePrice ? basePrice : 0,
        salesItemDiscount: e.SalesItemDiscount
          ? formatDigits(e.SalesItemDiscount / e.Quantity, decimal)
          : '0.00',
        salesOrderDiscountPrice: e.SalesItemDiscount
          ? formatDigits(e.SalesItemDiscount, decimal)
          : '0.00',
        totalPrice: e.TotalPrice ? formatDigits(e.TotalPrice, decimal) : '0.00',
        totalPriceReceipt: price,
        totalTax: e.TotalTax ? formatDigits(e.TotalTax, decimal) : '0.00',
        unitPrice: e.UnitPrice ? formatDigits(e.UnitPrice, decimal) : '0.00',
        promotions: promo && !isEmptyObject(promo) ? promo : {},
        promotionPercent: promoPercent
          ? formatDigits(promoPercent, decimal)
          : '0.00',
        priceBookValue: priceBookValue
          ? formatDigits(priceBookValue, decimal)
          : '0.00',
        priceBookPercent: pbPercent ? formatDigits(pbPercent, decimal) : '0.00',
        discountPercentage: e.salesItemDiscountPercent
          ? formatDigits(e.salesItemDiscountPercent, decimal)
          : 0,
        productNote: e.ProductNote ? e.ProductNote : '',
        variantName: e.VariantName ? e.VariantName : '',
        taxCode: showTaxCode ? taxCode : ''
      }
    })
  }
  dataToPrint.totalItems = salesOrderData.totalItems
  dataToPrint.products = toPrintProducts
  dataToPrint.additionalDiscount = wholeDisc
    ? formatDigits(wholeDisc, decimal)
    : ''
  dataToPrint.indexKey = salesOrderData.indexKey ? salesOrderData.indexKey : 0
  dataToPrint.isOffline = !dataToPrint.saleid ? true : false
  dataToPrint.barcode = generateSaleBarcode(
    getDecryptID(localStorage.getItem('storeReqNo')),
    sale && sale.E_OutletID ? getDecryptID(sale.E_OutletID) : false,
    sale && sale.E_RegisterID ? getDecryptID(sale.E_RegisterID) : false,
    dataToPrint.saleid ? dataToPrint.saleid : dataToPrint.indexKey
  )
  console.log(JSON.stringify(dataToPrint))
  dispatch(loadDataToPrint(dataToPrint))
  updateIndexSaleReceipt(dataToPrint, salesOrderData.indexKey)
}

export function SellProductJsonBuilder (
  SelectedSaleProductJsonData,
  promotionObject,
  builderType,
  getCustomerSearchData,
  getReduxSaleProductJsonData,
  getStoredBooks,
  getIsLoyaltyEnabled,
  getDefaultLoyaltyAmount,
  getIsTaxExclusive,
  getStoredPromos,
  getDefaultDecimalPlaces,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getIsRefundSale,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  getRefundKeys,
  getSalePayments,
  dispatch,
  getSalePromoCode,
  getSavings,
  flag,
  isExplicitZero,
  attribProps
) {
  try {
    let items = SelectedSaleProductJsonData
    const index_identity =
      getCurrentSalesOrderData && getCurrentSalesOrderData.indexKey
        ? getCurrentSalesOrderData.indexKey
        : getRandomInt(10000000000000)

    const item_index_identity = items.indexKey
      ? items.indexKey
      : `${index_identity}_${getRandomInt(10000)}`

    const selectedCustomer = getCustomerSearchData
    if (
      items != null &&
      items != undefined &&
      items != '' &&
      !isEmptyObject(items)
    ) {
      let rowKey = items.key != undefined ? items.key : ''
      let tempSaleProductsJson = getReduxSaleProductJsonData

      let totalTaxPercentageValue = 0
      let totalTaxFixValue = 0

      let basePrice = items.basePrice
      let taxesRevisionList = items.taxesRevisionList
      let baseTax = items.baseTax
      let displayBasePrice = items.basePrice
      let isRowDataPoke = false
      if (
        items.discountPoked ||
        (typeof items.displayDiscount == 'string' &&
          items.displayDiscount.includes('_ROWPOKED')) ||
        items.isRowDataPoke
      ) {
        isRowDataPoke = true
        if (
          items.displayDiscount &&
          typeof items.displayDiscount == 'string' &&
          items.displayDiscount.includes('_ROWPOKED')
        ) {
          items.displayDiscount = customParse(
            items.displayDiscount.split('_ROW')[0]
          )
        }
      }
      let displayDiscount = items.displayDiscount
        ? items.displayDiscount
        : items.salesItemDiscount
        ? items.salesItemDiscount
        : ''
      let displayDiscountPercent = items.displayDiscountPercent
        ? items.displayDiscountPercent
        : ''
      let salesItemDiscountPercent = items.salesItemDiscountPercent
        ? items.salesItemDiscountPercent
        : 0
      let displayMarkupPercent =
        items.displayMarkupPercent != undefined
          ? items.displayMarkupPercent
          : ''
      let discountIsPercentage = items.discountIsPercentage ? true : false
      let isRefund = items.isRefund ? true : false
      let isOnAccount = items.isOnAccount ? true : false
      let loyaltyValue = items.loyaltyValue
      let unitPrice = items.basePrice
      let isPromotionApplied =
        items.isPromotionApplied != undefined ? items.isPromotionApplied : false
      let isPriceBookApplied = items.isPriceBookApplied
        ? items.isPriceBookApplied
        : false
      let totals = {}
      let taxComponents = {}
      let bestPriceBookInfo = {}
      let selectedPriceBook = items.selectedPriceBook
        ? items.selectedPriceBook
        : {}
      let PromotionandPriceBookDetails = {}
      let refundPromoApplied = items.refundPromoApplied
        ? items.refundPromoApplied
        : 0
      let totalPriceDisplay = 0
      let adjusted =
        items.isPriceAdjusted != undefined ? items.isPriceAdjusted : false
      let productRowKey = items.key ? items.key : getRandomInt(100000000)
      items.key = productRowKey
      let displayQuantity = items.displayQuantity
      let priceBooks = items.priceBooks ? items.priceBooks : []
      let refundUnitPrice = 0
      let refundUnitPriceExc = 0
      const supplyPrice = items.supplyPrice
      const isProductInventory = items.isProductInventory
      const inventoryCheck = items.inventoryCheck ? items.inventoryCheck : false
      const currentInventory = items.currentInventory
      let negativeInventory = false
      let grandTotalQuantity = displayQuantity //total prod quantity in cart
      if (
        !isRefund &&
        !isOnAccount &&
        tempSaleProductsJson &&
        tempSaleProductsJson.length > 0
      ) {
        let sameProd = tempSaleProductsJson.filter(
          a =>
            !a.isRefund &&
            !a.isOnAccount &&
            getDecryptID(a.sProductID) == getDecryptID(items.sProductID)
        )
        sameProd &&
          sameProd.length > 0 &&
          sameProd
            .filter(c => c.sProductID != items.sProductID)
            .map(b => {
              grandTotalQuantity += b.displayQuantity
            })
      }
      items.grandTotalQuantity = grandTotalQuantity
      //inventory check
      if (inventoryCheck) {
        negativeInventory = grandTotalQuantity > currentInventory
        if (negativeInventory) {
          dispatch(loadShowInventoryPopup(true))
        } else {
          let isInvPopHide = true
          tempSaleProductsJson
            .filter(a => a.productName != items.productName)
            .map(x => {
              if (x.negativeInventory) {
                isInvPopHide = false
                return
              }
            })
          if (isInvPopHide) {
            dispatch(loadShowInventoryPopup(false))
          }
        }
      }

      //PB EFFECTS --> for all customer groups
      if (!isRowDataPoke && !isRefund && !isOnAccount) {
        // fetch pricebooks
        priceBooks = dispatch(
          getProductPriceBook(items.sProductID, getStoredBooks)
        )
        const pbData = priceBookEffects(priceBooks, selectedCustomer)
        isPriceBookApplied = pbData.isPriceBookApplied
        selectedPriceBook = pbData.selectedPriceBook
      }

      //taxes:
      const helperTax = prodTaxHelper(items, basePrice, displayQuantity) //assigning taxComp here to utilize total taxRate, (tax_val can be chnage later)
      taxComponents = helperTax.taxComponents
      taxComponents &&
        taxComponents.length > 0 &&
        taxComponents.map(zx => {
          if (!zx.indexKey) {
            zx.indexKey = `${index_identity}_${getRandomInt(10000)}`
          }
        })
      items = helperTax.items

      //preparing taxes total to implement
      totalTaxPercentageValue = 0
      totalTaxFixValue = 0
      if (items.taxComponents && items.taxComponents.length > 0) {
        items.taxComponents &&
          items.taxComponents.map(obj => {
            if (obj.isFix) totalTaxFixValue += obj.fixRate ? obj.fixRate : 0
            else totalTaxPercentageValue += customParse(obj.taxRate)
          })
      }

      baseTax = calculateRevBasedTax(
        totalTaxPercentageValue,
        totalTaxFixValue,
        items.basePrice
      )

      let displayPrice = 0
      let includedInOnAccOrRefund = false
      if (isRefund || isOnAccount) {
        includedInOnAccOrRefund = true
        //NOTE: the prod which is newly added to the refund sale or onAccount/LayBy sale should not come into this check
        const refundPrice = calculateRefundPrice(
          displayQuantity,
          items,
          getIsTaxExclusive,
          isOnAccount
        )
        promotionObject =
          items.promotionObject && !isEmptyObject(items.promotionObject)
            ? items.promotionObject
            : {}
        displayPrice = refundPrice.price
        refundUnitPrice = refundPrice.refundUnitPrice
        refundPromoApplied = refundPrice.refundPromoApplied
        refundUnitPriceExc = refundPrice.refundUnitPriceExc
        selectedPriceBook = refundPrice.selectedPriceBook
          ? refundPrice.selectedPriceBook
          : {}
        isPriceBookApplied = refundPrice.isPBApplied
          ? refundPrice.isPBApplied
          : false
      } else {
        displayPrice =
          items.displayPrice != null && items.displayPrice != undefined
            ? items.displayPrice
            : getIsTaxExclusive
            ? basePrice
            : basePrice + baseTax
      }

      let isAdjustedPrice =
        adjusted &&
        items.bestPriceBookInfo != undefined &&
        items.bestPriceBookInfo.price != ''

      // best Price Selection
      let bestBasePrice =
        isRefund || isOnAccount ? refundUnitPriceExc : basePrice ? basePrice : 0
      if (!isRowDataPoke && !isRefund && !isOnAccount) {
        const bestPInfo = bestPriceSelection(
          isAdjustedPrice,
          isPriceBookApplied,
          selectedPriceBook,
          bestBasePrice,
          basePrice,
          totalTaxPercentageValue,
          displayPrice,
          totalTaxFixValue
        )
        bestBasePrice = bestPInfo.bestBasePrice
      }

      bestPriceBookInfo = {
        explicitLoyaltyValue: false,
        loyaltyValue: 0,
        price: bestBasePrice,
        tax: calculateRevBasedTax(
          totalTaxPercentageValue,
          totalTaxFixValue,
          bestBasePrice
        )
      }
      displayBasePrice = getIsTaxExclusive ? basePrice : basePrice + baseTax
      const displayBBPrice = displayBasePrice * displayQuantity

      //#region promotion start
      var appliedPromotionObject = {}
      let promotionDataByProductID = {}
      var referencePromotion = {}
      if (!items.bestPriceBookInfo) {
        items.bestPriceBookInfo = bestPriceBookInfo
      }
      const promoHelper = promotionHelper(
        appliedPromotionObject,
        promotionDataByProductID,
        referencePromotion,
        items,
        promotionObject,
        isPromotionApplied,
        selectedCustomer,
        bestPriceBookInfo,
        grandTotalQuantity,
        isRowDataPoke,
        getStoredPromos,
        getSalePromoCode,
        getReduxSaleProductJsonData,
        displayQuantity,
        productRowKey,
        builderType,
        getCustomerSearchData,
        getStoredBooks,
        getIsLoyaltyEnabled,
        getDefaultLoyaltyAmount,
        getIsTaxExclusive,
        getDefaultDecimalPlaces,
        getSelectedOutlet,
        getSelectedReg,
        getBasicIsPercent,
        getIsRefundSale,
        getCurrentSalesOrderData,
        getCurrentSalesOrderStatusID,
        formDiscountPrice,
        formDiscountPercentage,
        formSellNotes,
        getRefundKeys,
        getSalePayments,
        dispatch,
        isRefund,
        isOnAccount,
        getSavings,
        totalTaxFixValue,
        attribProps
      )
      if (promoHelper && !isEmptyObject(promoHelper)) {
        appliedPromotionObject = promoHelper.appliedPromotionObject
        isPromotionApplied = promoHelper.isPromotionApplied
        referencePromotion = promoHelper.referencePromotion
        promotionObject = promoHelper.promotionObject
        promotionDataByProductID = promoHelper.promotionDataByProductID
      }

      // let taxAmountForPromo = 0;
      // if (isPromotionApplied && appliedPromotionObject && !isEmptyObject(appliedPromotionObject)) {
      //   taxAmountForPromo = calculateRevBasedTax(totalTaxPercentageValue, totalTaxFixValue, appliedPromotionObject.amount);
      // }
      PromotionandPriceBookDetails = {
        price_book_id: isPriceBookApplied
          ? selectedPriceBook && selectedPriceBook.priceBookID
          : '',
        pricebookValue: isPriceBookApplied ? bestPriceBookInfo.price : 0,
        lineItemPromotions:
          isPromotionApplied &&
          appliedPromotionObject &&
          !isEmptyObject(appliedPromotionObject)
            ? {
                promotionID: appliedPromotionObject.id,
                promotionName: appliedPromotionObject.name,
                promotionPrice: appliedPromotionObject.amount,
                promoCode: '',
                promoCodeId: '',
                quantity: displayQuantity,
                unit_discount:
                  appliedPromotionObject.unit_discount -
                  totalTaxPercentageValue, //taxAmountForPromo
                unit_price: bestPriceBookInfo.price,
                unit_tax: bestPriceBookInfo.tax,
                unit_tax_discount: 0
              }
            : null,
        AppliedPromotionDetails: isPromotionApplied
          ? [
              {
                amount:
                  Math.sign(appliedPromotionObject.amount) == -1
                    ? appliedPromotionObject.amount * -1
                    : appliedPromotionObject.amount,
                description: appliedPromotionObject.name,
                id: appliedPromotionObject.id,
                name: appliedPromotionObject.name,
                promoCode: ''
              }
            ]
          : [],
        ReferencePromotion: referencePromotion ? { ...referencePromotion } : {},
        promoCodeDetail:
          isPromotionApplied &&
          !isEmptyObject(appliedPromotionObject) &&
          appliedPromotionObject.codeDetail &&
          !isEmptyObject(appliedPromotionObject.codeDetail)
            ? appliedPromotionObject.codeDetail
            : false,
        appliedPromoClone: isPromotionApplied
          ? { ...appliedPromotionObject }
          : {}
      }

      //op for promoCode popOver
      const promoCodeDetails =
        !isEmptyObject(promotionDataByProductID) &&
        appliedPromotionObject.codeDetail &&
        !isEmptyObject(promotionDataByProductID.codeDetail)
          ? promotionDataByProductID.codeDetail
          : !isEmptyObject(appliedPromotionObject) &&
            appliedPromotionObject.codeDetail &&
            !isEmptyObject(appliedPromotionObject.codeDetail)
          ? appliedPromotionObject.codeDetail
          : {}
      if (
        !isEmptyObject(promoCodeDetails) &&
        promoCodeDetails.codeDetail &&
        !isEmptyObject(promoCodeDetails.codeDetail)
      ) {
        // promotionDataByProductID
        if (isPromotionApplied) {
          dispatch(laodPromoCodeNotify(1)) // 1 for applied // 2 for invalid // 3 req incomplete
          dispatch(loadIsPromoCodePopoverVisible(false))
        } else {
          dispatch(laodPromoCodeNotify(3)) // 1 for applied // 2 for invalid // 3 req incomplete
        }
      } else {
        dispatch(laodPromoCodeNotify(2)) // 1 for applied // 2 for invalid // 3 req incomplete
      }
      //#endregion promotion start

      //*****inclusive
      let priceDisplay =
        isRowDataPoke || isRefund || isOnAccount
          ? displayPrice / displayQuantity
          : getIsTaxExclusive
          ? bestPriceBookInfo.price
          : bestPriceBookInfo.price + bestPriceBookInfo.tax

      if (
        !isRefund &&
        !isOnAccount &&
        isPromotionApplied &&
        !isEmptyObject(appliedPromotionObject)
      ) {
        const promoPadjust = promoPriceEffect(
          priceDisplay,
          appliedPromotionObject,
          PromotionandPriceBookDetails,
          bestPriceBookInfo,
          displayQuantity,
          getIsTaxExclusive
        )
        if (promoPadjust && !isEmptyObject(promoPadjust)) {
          priceDisplay = promoPadjust.priceDisplay
        }
      }

      if (getIsRefundSale) {
        if (items.firstRefund) {
          priceDisplay = -priceDisplay
          displayQuantity = -displayQuantity
        }
      } else {
        priceDisplay =
          Math.sign(priceDisplay) == -1 || displayQuantity < 0
            ? 0.0
            : priceDisplay
      }

      displayPrice = priceDisplay
      totalPriceDisplay = displayPrice * displayQuantity
      if (displayPrice < 0 && displayQuantity < 0) {
        totalPriceDisplay = -totalPriceDisplay
      }

      //discounts apply
      if (isRowDataPoke || isPromotionApplied || isPriceBookApplied) {
        const totalPriceForDiscount = getIsTaxExclusive
          ? totalPriceDisplay
          : totalPriceDisplay -
            (totalTaxFixValue ? totalTaxFixValue * displayQuantity : 0)
        const basePriceForDiscount = getIsTaxExclusive
          ? displayBasePrice
          : displayBasePrice - (totalTaxFixValue ? totalTaxFixValue : 0)
        displayDiscount =
          basePriceForDiscount - totalPriceForDiscount / displayQuantity // items.displayQuantity
        displayDiscountPercent = (displayDiscount / basePriceForDiscount) * 100
        displayMarkupPercent = (displayDiscount / basePriceForDiscount) * 100
        displayDiscount *= displayQuantity
      } else {
        displayDiscount = 0
        displayDiscountPercent = 0
        displayMarkupPercent = 0
      }

      //setting best base price incase when promoApplied And Tax InclucsiveCase (not refund and onAccount case)
      if (
        !getIsTaxExclusive &&
        !isRefund &&
        !isOnAccount &&
        isPromotionApplied &&
        !isEmptyObject(appliedPromotionObject)
      ) {
        let baseTaxForPromo = 0
        if (baseTax) {
          baseTaxForPromo = baseTax - (totalTaxFixValue ? totalTaxFixValue : 0)
        }
        const discTax =
          baseTaxForPromo - baseTaxForPromo * (displayDiscountPercent / 100)
        bestBasePrice =
          priceDisplay -
          discTax -
          (getIsTaxExclusive ? 0 : totalTaxFixValue ? totalTaxFixValue : 0)
        // if (appliedPromotionObject.isOffEntireSale) {
        //   const discTax = baseTax - (baseTax * (displayDiscountPercent / 100));
        //   bestBasePrice = priceDisplay - discTax;
        // } else {
        //   const varVal = bestPriceBookInfo.price + bestPriceBookInfo.tax;
        //   const diff = varVal - priceDisplay;
        //   if (diff && diff > 0) {
        //     const ratio = varVal / diff;
        //     if (ratio && ratio > 0) {
        //       bestBasePrice -= (bestBasePrice * (ratio / 100));
        //     }
        //   }
        // }
      }

      // const taxAmountForBasePrice = calculateRevBasedTax(totalTaxPercentageValue, totalTaxFixValue, basePrice);
      const baseTtax = baseTax * displayQuantity
      const excBPrice = basePrice * displayQuantity
      const incBPrice =
        basePrice +
        calculateRevBasedTax(
          totalTaxPercentageValue,
          totalTaxFixValue,
          basePrice
        ) //displayQuantity
      // const incBPrice = (basePrice + taxAmountForBasePrice) * displayQuantity;
      const totalBasePrice = bestBasePrice * displayQuantity
      const taxAmountForTotalBasePrice = calculateRevBasedTax(
        totalTaxPercentageValue,
        totalTaxFixValue,
        totalBasePrice,
        displayQuantity
      )

      let excAlturPrice = totalBasePrice
      if (isRowDataPoke && adjusted) {
        if (getIsTaxExclusive) {
          excAlturPrice = totalPriceDisplay
        } else {
          const pokedValue = includedInOnAccOrRefund
            ? 0
            : excAlturPrice * (displayDiscountPercent / 100)
          excAlturPrice = excAlturPrice - pokedValue
        }
      } else if (getIsTaxExclusive) {
        excAlturPrice = totalPriceDisplay
      } else if (
        displayDiscount > 0 &&
        !isPriceBookApplied &&
        !isPromotionApplied
      ) {
        // excAlturPrice = includedInOnAccOrRefund ? totalBasePrice : totalBasePrice - (totalBasePrice * displayDiscountPercent / 100);
        excAlturPrice = includedInOnAccOrRefund
          ? totalPriceDisplay - taxAmountForTotalBasePrice
          : totalBasePrice - (totalBasePrice * displayDiscountPercent) / 100
      } else {
        excAlturPrice = totalPriceDisplay - taxAmountForTotalBasePrice //totalPriceDisplay
      }

      //totalTax
      let totalTtax = 0
      let totalTaxFix = 0
      let incPrice = excAlturPrice
      unitPrice = excAlturPrice

      //******taxComponent changes***********
      if (
        taxComponents != undefined &&
        taxComponents != null &&
        !isEmptyObject(taxComponents)
      ) {
        taxComponents.map((obj, key) => {
          const baseTotalTax = obj.isFix
            ? obj.total_tax
            : basePrice * displayQuantity * obj.taxRate
          obj.base_total_tax = baseTotalTax
          obj.total_tax = obj.isFix
            ? obj.total_tax *
              (obj.total_tax > 0 && displayQuantity < 0 ? -1 : 1)
            : unitPrice * obj.taxRate
          obj.replica = obj.total_tax
        })

        //getting totals
        taxComponents.map(qw => {
          totalTtax += qw.total_tax
          incPrice += qw.total_tax
          if (qw.isFix) {
            totalTaxFix += qw.total_tax
          }
        })
      }
      const totalTaxWithoutFix = totalTtax != 0 ? totalTtax - totalTaxFix : 0

      // promoeffect for onAccount or refund
      if ((isRefund || isOnAccount) && isPromotionApplied) {
        const promoTotalValue = refundPromoApplied * displayQuantity
        let val = promoTotalValue - totalPriceDisplay
        val = val < 0 ? val * -1 : val
        if (
          PromotionandPriceBookDetails.AppliedPromotionDetails &&
          PromotionandPriceBookDetails.AppliedPromotionDetails.length > 0
        ) {
          PromotionandPriceBookDetails.AppliedPromotionDetails[0].amount = val
        }
        if (PromotionandPriceBookDetails.appliedPromoClone) {
          PromotionandPriceBookDetails.appliedPromoClone.amount = val
        }
      }

      // price book value assigning
      const pbValue =
        displayBBPrice > totalPriceDisplay
          ? displayBBPrice - totalPriceDisplay
          : 0
      if (
        isPriceBookApplied &&
        PromotionandPriceBookDetails &&
        PromotionandPriceBookDetails.pricebookValue
      ) {
        PromotionandPriceBookDetails.pricebookValue = pbValue
        if (
          isPromotionApplied &&
          PromotionandPriceBookDetails.AppliedPromotionDetails &&
          PromotionandPriceBookDetails.AppliedPromotionDetails.length > 0
        ) {
          if (PromotionandPriceBookDetails.AppliedPromotionDetails[0].amount) {
            PromotionandPriceBookDetails.pricebookValue -=
              PromotionandPriceBookDetails.AppliedPromotionDetails[0].amount < 0
                ? PromotionandPriceBookDetails.AppliedPromotionDetails[0]
                    .amount * -1
                : PromotionandPriceBookDetails.AppliedPromotionDetails[0].amount
          }
        }
      }

      // assigning - + to promotion final value
      if (
        isPromotionApplied &&
        PromotionandPriceBookDetails &&
        !isEmptyObject(PromotionandPriceBookDetails)
      ) {
        const val = displayQuantity < 0 ? 1 : -1
        if (
          PromotionandPriceBookDetails.AppliedPromotionDetails &&
          PromotionandPriceBookDetails.AppliedPromotionDetails.length > 0
        ) {
          PromotionandPriceBookDetails.AppliedPromotionDetails[0].amount *= val
        }
      }

      totals = {
        baseTax: baseTtax ? baseTtax : 0,
        displayBasePrice: displayBBPrice ? displayBBPrice : 0,
        displayPrice: totalPriceDisplay ? totalPriceDisplay : 0,
        unitPrice: unitPrice ? unitPrice : 0,
        exclusiveBasePrice: excBPrice ? excBPrice : 0,
        exclusivePrice: excAlturPrice ? excAlturPrice : 0,
        subtotal: excAlturPrice ? excAlturPrice : 0,
        inclusiveBasePrice: incBPrice ? incBPrice : 0,
        inclusivePrice: incPrice ? incPrice : 0,
        fixTaxAmount: totalTaxFixValue * displayQuantity
      }
      const selectedProductJson = {
        displayQuantity: displayQuantity,
        grandTotalQuantity: grandTotalQuantity,
        basePrice: basePrice,
        baseTax: baseTax,
        bestPriceBookInfo: bestPriceBookInfo,
        displayBasePrice: displayBasePrice ? displayBasePrice : 0,
        salesItemDiscountPercent:
          isRowDataPoke && !isPromotionApplied && displayDiscountPercent
            ? displayDiscountPercent
            : 0,
        displayDiscount:
          isRowDataPoke && !isPromotionApplied && displayDiscount
            ? displayDiscount
            : 0,
        displayDiscountPercent: formatDigits(
          displayDiscountPercent ? displayDiscountPercent : 0,
          getDefaultDecimalPlaces
        ),
        displayMarkupPercent: displayMarkupPercent ? displayMarkupPercent : 0,
        discountIsPercentage: discountIsPercentage,
        displayPrice: totalPriceDisplay ? totalPriceDisplay : 0,
        loyaltyValue: 0,
        unitPrice: unitPrice ? unitPrice : 0,
        totalTax: totalTtax ? totalTtax : 0,
        totalTaxWithoutFix: totalTaxWithoutFix ? totalTaxWithoutFix : 0,
        key: productRowKey,
        sSalesOrderID: items.sSalesOrderID,
        sSalesOrderItemID: items.sSalesOrderItemID,
        orderTrackingID: items.orderTrackingID ? items.orderTrackingID : '',
        sProductID: items.sProductID,
        tax_id: items.tax_id,
        isRemoveProduct: items.isRemoveProduct,
        productName: items.productName,
        isPriceAdjusted: adjusted,
        productNote: items.productNote != undefined ? items.productNote : '',
        isPromotionApplied: isPromotionApplied,
        isPriceBookApplied: isPriceBookApplied,
        taxComponents: taxComponents,
        // taxComponents: !isEmptyObject(PromotionandPriceBookDetails) && !isEmptyObject(PromotionandPriceBookDetails.ReferencePromotion)
        //   && PromotionandPriceBookDetails.ReferencePromotion.isPayFix ? [] : taxComponents,
        priceBooks: priceBooks,
        PromotionandPriceBookDetails: PromotionandPriceBookDetails,
        totals: totals,
        isRowDataPoke: isRowDataPoke,
        currentInventory: currentInventory,
        isProductInventory: isProductInventory,
        negativeInventory: negativeInventory,
        inventoryCheck: inventoryCheck,
        supplyPrice: supplyPrice,
        SalesItemDiscountPercent: 0,
        isOnAccount: isOnAccount,
        isRefund: isRefund,
        promotionObject:
          (isRefund || isOnAccount) && isPromotionApplied
            ? promotionObject
            : {},
        refundUnitPrice:
          (isRefund || isOnAccount) && refundUnitPrice ? refundUnitPrice : 0,
        refundPromoApplied: isRefund || isOnAccount ? refundPromoApplied : 0,
        refundUnitPriceExc: isRefund || isOnAccount ? refundUnitPriceExc : 0,
        selectedPriceBook: isRefund || isOnAccount ? selectedPriceBook : {},
        taxesRevisionList: taxesRevisionList,
        totalTaxFixValue: totalTaxFixValue ? totalTaxFixValue : 0,
        variantName: items.variantName ? items.variantName : '',

        indexKey: item_index_identity,

        identityInfo: items.identityInfo ? items.identityInfo : {},

        userID: items.userID ? items.userID : 0
      }

      if (
        selectedProductJson.key &&
        tempSaleProductsJson.filter(a => a.key === rowKey)[0]
      ) {
        let index = getReduxSaleProductJsonData.indexOf(
          getReduxSaleProductJsonData.filter(a => a.key == rowKey)[0]
        )

        tempSaleProductsJson[index] = selectedProductJson
        dispatch(loadSaleProductJsonData(tempSaleProductsJson))
      } else {
        if (builderType != 'runner') {
          dispatch(
            loadSaleProductJsonData(
              tempSaleProductsJson.concat(selectedProductJson)
            )
          )
        }
      }

      dispatch(loadIsProductLoading(false))
      return selectedProductJson
    }
  } catch (ex) {
    dispatch(loadIsProductLoading(false))
    dispatch(loadIsPaymentPanelLoading(false))
    dispatch(loadIsMainLoading(false))
    // console.log(
    //   `${SelectedSaleProductJsonData.productName} YAHOO_PROBLEM_XX`,
    //   ex
    // )
    message.warn(`Loading ...`)
  }
}

function updateIndexSaleReceipt (data, indexKey) {
  const req = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  req
    .then(async e => {
      const saleExist = e.filter(er => er.indexKey == indexKey)
      if (saleExist && saleExist.length > 0) {
        let sale = { ...saleExist[0] }
        sale.printData = data
        await saveEntitiesDatatoIndexBD(
          [sale],
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.SALES,
          'updateIndexSaleReceipt'
        )
      }
    })
    .catch(e => {
      console.log('INDEX_DB_ERROR_FOR_PRINT -> updateIndexSaleReceipt -->', e)
    })
}
